module.exports = __webpack_public_path__ + "img/vn_checksign.3193edf3.png";